import React, { Component } from "react";

import { Header, Segment, Input } from "semantic-ui-react";

import {
  publicJoinLinkChanged,
  changePublicJoinLink
} from "../../../actions/reimbursements";

import { connect } from "react-redux";

import SubmitterTable from "../../../components/SubmitterTable";

class _PublicJoinLinkToggle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false
    };
  }

  setPublicLinkState = enable => {
    this.setState({
      submitting: true
    });
    changePublicJoinLink(enable)
      .then(newData => {
        this.props.publicJoinLinkChanged(newData);
      })
      .finally(() => {
        this.setState({
          submitting: false
        });
      });
  };

  renderEnabled() {
    return (
      <Segment color="green">
        <Header dividing>
          Submitter Join Link
          <Header.Subheader>
            Send this link out to let people to add themselves as submitters.
          </Header.Subheader>
        </Header>
        <Input
          label="Link"
          fluid
          value={
            window.location.protocol +
            "//" +
            window.location.host +
            "/_/submitter_signup/" +
            this.props.publicJoinLink.uuid +
            "/" +
            this.props.publicJoinLink.modify_key
          }
          actionPosition="right"
          action={{
            content: "Disable",
            secondary: true,
            onClick: () => this.setPublicLinkState(false),
            loading: this.state.submitting
          }}
        />
      </Segment>
    );
  }

  renderDisabled() {
    return (
      <Segment color="grey">
        <Header dividing>
          Submitter Join Link
          <Header.Subheader>
            Send this link out to let people to add themselves as submitters.
          </Header.Subheader>
        </Header>
        <Input
          label="Link"
          fluid
          value="No public join link."
          actionPosition="right"
          action={{
            content: "Enable",
            primary: true,
            onClick: () => this.setPublicLinkState(true),
            loading: this.state.submitting
          }}
        />
      </Segment>
    );
  }

  render() {
    if (this.props.publicJoinLink.enabled) {
      return this.renderEnabled();
    } else {
      return this.renderDisabled();
    }
  }
}

const publicJoinLinkMSTP = state => ({
  publicJoinLink: state.reimbursements.public_join_link
});

const publicJoinLinkMDTP = dispatch => ({
  publicJoinLinkChanged: newData => dispatch(publicJoinLinkChanged(newData))
});

const PublicJoinLinkToggle = connect(
  publicJoinLinkMSTP,
  publicJoinLinkMDTP
)(_PublicJoinLinkToggle);

const PeopleView = props => {
  return (
    <div>
      <Header dividing as="h3">
        <Header.Content>
          Reimbursement Submitters
          <Header.Subheader>All people</Header.Subheader>
        </Header.Content>
      </Header>
      <PublicJoinLinkToggle />
      <SubmitterTable people={props.submitters} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    submitters: state.reimbursements.submitters
  };
};

export default connect(mapStateToProps)(PeopleView);



// WEBPACK FOOTER //
// ./frontend/src/views/pages/reimbursements/PeopleView.js